import { CommonService, ServiceHistoryCheckSubmitModel } from 'api-new/generated';
import { QueryError, formatErrorMessage } from 'features/shared/model';
import { UseMutationOptions, useMutation } from 'react-query';
import { toast } from 'react-toastify';

export type ServiceHistoryCheckSaveParams = {
  regNo: string;
  typeId: number;
};

export const useServiceHistoryCheckSaveMutation = (
  options?: Omit<
    UseMutationOptions<
      Awaited<ReturnType<typeof CommonService.postCommonServiceHistoryCheck>>,
      QueryError,
      ServiceHistoryCheckSaveParams,
      unknown
    >,
    'mutationFn'
  >
) =>
  useMutation(
    (input: ServiceHistoryCheckSaveParams) =>
      CommonService.postCommonServiceHistoryCheck({
        regNo: input.regNo,
        typeId: input.typeId
      } as ServiceHistoryCheckSubmitModel),
    {
      ...options,
      onError: (error: QueryError) => {
        const message = formatErrorMessage(error);
        toast.error(message);
        console.error(message);
      }
    }
  );
